<h1 class="h3 mb-2 text-gray-800">Paciente: {{caso && caso.paciente}}</h1>

<div class="card shadow mb-4">
    <div class="card-body">
        <div class="row">
            <div class="col-9">
                <div class="row">
                    <div class="col" *ngIf="caso">
                        <h5>Estado</h5>
                        <div>{{getEstado()}}</div>
                        <ng-container
                            *ngIf="caso.status == estadosCaso.CASO_RECHAZADO_ENVIE_INFO || caso.status == estadosCaso.PAGO_INICIAL_ERRONEO|| caso.status == estadosCaso.PAGO_TRATAMIENTO_ERRONEO || caso.status == estadosCaso.CASO_ENTREGADO_RECHAZADO">
                            <div><b>Motivo:</b> {{caso.motivo_rechazo}}</div>
                        </ng-container>
                        <ng-container *ngIf="caso.status == estadosCaso.PAGO_TRATAMIENTO_COMPROBADO">
                            <div><b>Dirección entrega:</b> {{caso.direccion_entrega}}</div>
                            <div *ngIf="caso.latitudEntrega"><a [href]="getGoogleMapsLink()"
                                    target="_blank">Ver
                                    ubicación</a></div>
                        </ng-container>
                    </div>
                    <div class="col text-right" *ngIf="caso && caso.precio_tratamiento_bs">
                        <h5>Presupuesto en Bs</h5>
                        <div>
                            <div>{{caso.precio_tratamiento_bs}} Bs</div>
                        </div>
                    </div>
                </div>

                <div class="card mt-3">
                    <div class="card-body">
                        <h5>Refinamientos</h5>
                        <div *ngIf="refinamientos?.length==0">
                            Este paciente no tiene ningún refinamiento
                        </div>
                        <div *ngIf="refinamientos?.length > 0" class="table-responsive">
                            <table [dtOptions]="dtOptions" datatable class="row-border hover">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Motivo</th>
                                        <th>Alin sup</th>
                                        <th>Alin inf</th>
                                        <th>Presup.</th>
                                        <th>Estado</th>
                                        <th></th>
                                        <th *ngIf="isAdmin"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr app-refinamientoitem *ngFor="let refinamiento of refinamientos"
                                        (onRefinamientoChanged)="reloadRefinamientos()" [isDoctor]="isDoctor"
                                        [isAdmin]="isAdmin" [refinamiento]="refinamiento">
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3" *ngIf="caso">
                <a *ngIf="caso.status == estadosCaso.CASO_ENTREGADO_Y_APROBADO"
                    [routerLink]="[ '/refinamientos/', caso.id ]" class="btn btn-block btn-outline-success"><i
                        class="bi bi-clipboard-plus"></i> Realizar
                    Refinamiento</a>
                <ng-container *ngIf="isAdmin">
                    <a *ngIf="caso.status == estadosCaso.PAGO_INICIAL_ENVIADO"
                        [routerLink]="[ '/casos/comprobante-inicial/', caso.id ]"
                        class="btn btn-secondary btn-block mt-2">Ver
                        comprobante inicial</a>
                    <a *ngIf="caso.status == estadosCaso.PAGO_TRATAMIENTO_REALIZADO"
                        [routerLink]="[ '/casos/comprobante-tratamiento/', caso.id ]"
                        class="btn btn-secondary btn-block mt-2">Ver
                        comprobante tratamiento</a>
                    <a *ngIf="caso.status == estadosCaso.TRATAMIENTO_SOLICITADO || caso.status == estadosCaso.CASO_ENTREGADO_RECHAZADO"
                        [routerLink]="[ '/planestratamiento/', caso.id ]" class="btn btn-secondary btn-block">Ver
                        tratamiento solicitado</a>
                    <a *ngIf="caso.status == estadosCaso.PAGO_TRATAMIENTO_COMPROBADO"
                        class="btn btn-secondary btn-block mt-2" (click)="entregarCaso(caso)"
                        href="javascript:void(0)">Marcar como entregado</a>
                </ng-container>

                <ng-container *ngIf="isDoctor || isAdmin">
                    <div>
                        <a *ngIf="caso.status == estadosCaso.APROBACION_SOLICITADA"
                            [routerLink]="[ '/casos/ver/', caso.id ]" class="btn btn-secondary btn-block mt-2"><i
                                class="bi bi-file-text"></i> Ver caso</a>
                        <a *ngIf="caso.status == estadosCaso.CASO_APROBADO || caso.status == estadosCaso.PAGO_INICIAL_ERRONEO"
                            [routerLink]="[ '/casos/paso2/', caso.id ]"
                            class="btn btn-secondary btn-block mt-2">Realizar
                            Pago Inicial</a>
                        <a *ngIf="caso.status == estadosCaso.TRATAMIENTO_APROBADO_PAGO_SOLICITADO || caso.status == estadosCaso.PAGO_TRATAMIENTO_ERRONEO"
                            [routerLink]="[ '/casos/paso4/', caso.id ]"
                            class="btn btn-secondary btn-block mt-2">Realizar
                            Pago de Tratamiento</a>
                        <a *ngIf="caso.status == estadosCaso.PAGO_INICIAL_VERIFICADO"
                            [routerLink]="[ '/planestratamiento/', caso.id ]"
                            class="btn btn-secondary btn-block mt-2">Plan
                            de Tratamiento</a>
                        <a *ngIf="caso.status == estadosCaso.CASO_ENTREGADO" class="btn btn-secondary btn-block mt-2"
                            [routerLink]="[ '/casos/verresultados/', caso.id ]">Ver Resultados</a>
                    </div>
                    <ng-container *ngIf="!tieneSolicitudesAbiertas(caso)">
                        <div>
                            <a *ngIf="isVerPlanVisible" [routerLink]="[ '/formulario/ver/', caso.id ]"
                                class="btn btn-success btn-block mt-2"><i class="bi bi-file-medical"></i> Ver plan de
                                tratamiento</a>
                            <a [routerLink]="[ '/archivos/ver/', caso.id ]" class="btn btn-success btn-block mt-2"><i
                                    class="bi bi-eye"></i> Ver archivos</a>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tieneSolicitudesAbiertas(caso)">
                        <div>
                            <a [routerLink]="[ '/casos/'+ caso.id+'/solicitudes' ]"
                                class="btn btn-secondary btn-block mt-2">Información solicitada</a>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isAdmin">
                        <a *ngIf="isModificarTratamientoVisible" [routerLink]="[ '/planestratamiento/', caso.id ]"
                            class="btn btn-outline-dark btn-block mt-2">Modificar
                            tratamiento solicitado</a>
                        <a [href]="getZipUrl(caso.id)" class="btn btn-success btn-block mt-2"><i
                                class="bi bi-download"></i>
                            Descargar archivos</a>
                        <div>
                            <app-solicitarinformacion type="block" [caso]="caso"></app-solicitarinformacion>
                            <a class="btn btn-outline-primary btn-block mt-2"
                                [routerLink]="['/casos/'+caso.id+'/solicitudes']">Información
                                Solicitada</a>
                        </div>
                        <button class="btn btn-danger btn-block mt-2" (click)="eliminarCaso(caso.id)"><i
                                class="bi bi-trash"></i> Eliminar</button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>